import { DaoModel } from '@dynameat/models';

export class ProductRecommendation extends DaoModel {
  constructor(guid, textAlt1, textAlt2, textAlt3, parentProduct, childProducts) {
    super(guid);
    this.text_alt1 = textAlt1 || '';
    this.text_alt2 = textAlt2 || '';
    this.text_alt3 = textAlt3 || '';
    this.parentProduct = parentProduct || null;
    this.childProducts = childProducts || [];
  }

  static toInstance(props = {}) {
    return new ProductRecommendation(
      props.guid,
      props.text_alt1,
      props.text_alt2,
      props.text_alt3,
      props.parent_product,
      props.child_products,
    );
  }

  serialize() {
    return {
      text_alt1: this.text_alt1,
      text_alt2: this.text_alt2,
      text_alt3: this.text_alt3,
      parent_product: this.parentProduct,
      child_products: this.childProducts,
    };
  }

  get text() {
    return this.text_alt1;
  }

  getParentName(masterProductList) {
    return masterProductList.find((el) => el.guid === this.parentProduct)?.name || '';
  }

  getChildNames(masterProductList) {
    return this.childProducts.map((guid) => masterProductList.find((el) => el.guid === guid)?.name || '');
  }
}
